import propTypes from 'prop-types';

Spinner.propTypes = {
  type: propTypes.string,
  margin: propTypes.string
};

export default function Spinner({ type, margin }) {
  const isRelative = type && type.includes('-relative');
  
  let spinnerSize = 'spinner-lg';
  if (type) {
    if (type.includes('spinner-xs')) spinnerSize = 'spinner-xs';
    else if (type.includes('spinner-sm')) spinnerSize = 'spinner-sm';
    else if (type.includes('spinner-md')) spinnerSize = 'spinner-md';
    else if (type.includes('spinner-xl')) spinnerSize = 'spinner-xl';
  }

  if (isRelative) {
    return (
      <div style={{ 
        position: 'relative', 
        width: '100%', 
        height: '100%', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center' 
      }}>
         <div className={`spinner-border corporativo ${spinnerSize}`} role="status">
          <span className="sr-only">Cargando...</span>
        </div>
      </div>
    );
  }

  // Modo pantalla completa (default)
  const containerClass = margin ? `main-holder ${margin}` : 'main-holder';

  return (
    <div className={containerClass}>
      <div 
        className={`spinner-border corporativo ${spinnerSize} spinner-centered`} 
        role="status"
        // Style inline para reforzar el fixed y z-index máximo como en la v1
        style={{ position: 'fixed', zIndex: '9999999999' }} 
      >
        <span className="sr-only">Cargando...</span>
      </div>
    </div>
  );
}


